import React from 'react';
import styled from '@emotion/styled';
import useI18n from '~Translations';

const ColorInfo = styled.div`
  flex: 1;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
`;

const ColorInfoText = styled.div`
  color: #666b71;
  font-size: 14px;
  letter-spacing: 0.24px;
  line-height: 24px;
  margin: 0 12px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
`;

const ColorDot = styled.span`
  height: 16px;
  width: 16px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 8px;
`;

const StatusColorInfo = () => {
  const { i18n } = useI18n();
  return (
    <ColorInfo>
      <ColorInfoText>
        <ColorDot style={{ backgroundColor: 'var(--colorUIBlue)' }} />
        {i18n('KDS.Accepted')}
      </ColorInfoText>
      <ColorInfoText>
        <ColorDot style={{ backgroundColor: 'var(--colorUIOrange)' }} />
        {i18n('KDS.Finalizing')}
      </ColorInfoText>
      <ColorInfoText>
        <ColorDot style={{ backgroundColor: 'var(--colorUIGreen)' }} />
        {i18n('KDS.Ready')}
      </ColorInfoText>
      <ColorInfoText>
        <ColorDot style={{ backgroundColor: 'var(--colorUIRed)' }} />
        {i18n('KDS.Overdue')}
      </ColorInfoText>
    </ColorInfo>
  );
};

export default StatusColorInfo;
